import React from "react";
import { Navbar, Container, Nav, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import HeaderLogo from "../../assets/logo (2).svg";
import {
  home_nav_content1,
  home_nav_content2,
  home_nav_content3,
  home_nav_content4,
} from "../../utility/constants";
import {
  news_subnav_content2,
  news_subnav_content1,
  news_subnav_content3,
  news_subnav_content4,
} from "../../utility/constants";
import FBIcon from "../../assets/fb.svg";
import InstaIcon from "../../assets/insta.svg";
import LinkedInIcon from "../../assets/in.svg";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useState } from "react";
import search from "../../assets/logo (2).svg";

function Header() {
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);

  const handleOffcanvasToggle = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  const handleOffcanvasClose = () => {
    setOffcanvasOpen(false);
  };
  return (
    <header className="fixed header-transparent bg-white">
      <Navbar
        expand="lg"
        className="nav-row first-row"
        style={{ padding: "20px" }}
      >
        <Link to="/homepage" className="text-decoration-none">
          <Navbar.Brand className="brand-logo">
            <img
              src={search}
              width="178px"
              height="33px"
              alt="React Bootstrap logo"
            />
          </Navbar.Brand>
        </Link>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={handleOffcanvasToggle}
        />
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          className="office-offcanvas-custom"
          show={offcanvasOpen}
          onHide={handleOffcanvasClose}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Navbar.Collapse
              id="basic-navbar-nav"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Nav className="menu list-inline m-0" id="menu">
                {/* <NavDropdown.Item> */}
                <Nav.Link
                  as={Link}
                  to="/Office"
                  className={offcanvasOpen ? "white-text" : "black-text"}
                  // href="/Office"
                >
                  Office
                </Nav.Link>
                {/* </NavDropdown.Item> */}
                {/* <NavDropdown.Item href="#action3"> */}
                {/* <Link to="/works" className="text-decoration-none"> */}
                <Nav.Link
                  as={Link}
                  to="/Works"
                  className={offcanvasOpen ? "white-text" : "black-text"}
                  // href="/Works"
                >
                  Works
                </Nav.Link>
                {/* </Link> */}
                {/* </NavDropdown.Item> */}
                {/* <NavDropdown.Item href="#action3"> */}
                <Nav.Link
                  as={Link}
                  to="/news"
                  className={`${offcanvasOpen ? "white-text" : "black-text"}`}
                  // href="/news"
                >
                  News
                </Nav.Link>
                {/* </NavDropdown.Item> */}

                {/* <NavDropdown.Item href="#action3" className="active"> */}
                <Nav.Link
                  as={Link}
                  to="/contact"
                  className={`${
                    offcanvasOpen ? "white-text" : "black-text"
                  } active`}
                  // href="/contact"
                >
                  Contact
                </Nav.Link>
                {/* </NavDropdown.Item> */}
              </Nav>
            </Navbar.Collapse>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Navbar>
    </header>
  );
}

export default Header;
